import { isEmpty, flatten } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import { fileSizeFormat } from '@fiverr-private/localization';
import type { DropzoneProps } from '../types';

export const getDisclaimerMessage = ({
    maxSize,
    accept,
    maxFiles,
}: Pick<DropzoneProps, 'maxSize' | 'accept' | 'maxFiles'>) => {
    const messageParts: string[] = [];
    const acceptExtensions = flatten(accept ? Object.values(accept) : []);
    const maxSizeStr =
        maxSize &&
        fileSizeFormat({
            bytes: maxSize,
            options: {
                maximumFractionDigits: 0,
            },
        });
    const hasExtensions = !isEmpty(acceptExtensions);
    const hasMaxSize = Boolean(maxSizeStr);
    const hasMaxFiles = Boolean(maxFiles);

    if (hasExtensions) {
        messageParts.push(
            `${translate('dropzone.idle_body.disclaimer.upload_formats')}\n${acceptExtensions.join(', ')}`
        );
    }

    if (hasMaxSize) {
        messageParts.push(
            translate('dropzone.idle_body.disclaimer.max_size', {
                params: {
                    max_size: maxSizeStr,
                },
            })
        );
    }

    if (hasMaxFiles) {
        messageParts.push(
            translate('dropzone.idle_body.disclaimer.max_files', {
                params: {
                    max_files: maxFiles,
                },
            })
        );
    }

    return messageParts.join('; ');
};
